import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PublicationModel, PublicationSaveModel} from '../../models/publication.model';
import {
    PublicationInformationFormPartComponent
} from '../../components/publication-registration/base-publication-form-part/publication-information-form-part/publication-information-form-part.component';
import {ConfirmationService} from 'primeng/api';
import {I18nService} from '../../../shared/i18n';
import {PublicationService} from '../../services/publication.service';
import {NotificationService} from '../../../shared/utils/notification.service';
import {AppCommunicationService} from '../../services/app-communication.service';
import {HistoryModel} from '../../models/historyModel';
import {HistoryService} from '../../services/history.service';
import {Observable} from 'rxjs/Observable';
import {ErrorCodesEnum, getErrorByCode} from '../../constants';

@Component({
    selector: 'app-publication-review-view',
    templateUrl: './publication-review-view.component.html',
    styleUrls: ['./publication-review-view.component.scss']
})
export class PublicationReviewViewComponent implements OnInit {
    sections = {
        first: {
            visited: true,
            valid: true
        },
        second: {
            visited: true,
            valid: true
        },
        third: {
            visited: true,
            valid: true
        },
        fourth: {
            visited: true,
            valid: true
        },
        all: {
            visited: true,
            valid: true
        }
    };
    assignIsbn = false;
    choosenIsbnId = 0;
    allActionHistory: HistoryModel[] = [];
    isbnReportGenerateAction: HistoryModel = null;
    pvReportGenerateAction: HistoryModel = null;

    publication: PublicationModel = new PublicationModel();
    @ViewChild(PublicationInformationFormPartComponent) publicationInformationFormPartComponent: PublicationInformationFormPartComponent;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private confirmationService: ConfirmationService,
                private i18nService: I18nService,
                private publicationService: PublicationService,
                private notificationService: NotificationService,
                private historyService: HistoryService,
                private _appCommunicationService: AppCommunicationService) {
    }

    ngOnInit() {
        const id = Number(this.route.snapshot.paramMap.get('id'));
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
        });
        const getPublicaiton = this.publicationService.getPublication(id);
        const getHistory = this.historyService.getHistoryForPublication(id);
        Observable.forkJoin([getPublicaiton, getHistory]).subscribe(
            (data: any[]) => {
                this.publication = data[0];
                this.allActionHistory = data[1];
                if (data[1].filter(h => h.historyType === 101).length === 1) {
                    this.isbnReportGenerateAction = data[1].filter(h => h.historyType === 101)[0];
                }
                if (data[1].filter(h => h.historyType === 102).length === 1) {
                    this.pvReportGenerateAction = data[1].filter(h => h.historyType === 102)[0];
                }
                if (data && data[1] && data[1][0] && data[1][0].comment) {
                    this.publication.comment = data[1][0].comment;
                }
                this.publicationInformationFormPartComponent.setFormValue(this.publication);
                this._appCommunicationService.loadingOff();
            }, err => {
                console.error(err);
                this._appCommunicationService.loadingOff();
            });
    }

    onVisitSection(index: number) {
        switch (index) {
            case 1:
                this.sections.first.visited = true;
                break;
            case 2:
                this.sections.second.visited = true;
                break;
            case 3:
                this.sections.third.visited = true;
                break;
            case 4:
                this.sections.fourth.visited = true;
                break;
        }
        this.sections.all.visited = this.sections.fourth.visited && this.sections.third.visited &&
            this.sections.second.visited && this.sections.first.visited
    }

    onValidChange(index: number, $event) {
        switch (index) {
            case 1:
                this.sections.first.valid = $event;
                break;
            case 2:
                this.sections.second.valid = $event;
                break;
            case 3:
                this.sections.third.valid = $event;
                break;
            case 4:
                this.sections.fourth.valid = $event;
                break;
        }
        this.sections.all.valid = this.sections.fourth.valid && this.sections.third.valid &&
            this.sections.second.valid && this.sections.first.valid
    }

    onBackClick() {
        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmBackToPublicationList'),
            buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                this.i18nService.getTranslation('Yes') + ']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                this.router.navigate(['/publications']);
            }
        });

    }

    onAuthorChange($event) {
        this.publication.authors = $event;
    }

    onModelUpdate(_publication: PublicationModel) {
        // this.publication. categoryType=_publication.categoryType;
        this.publication.thematicGroupType = _publication.thematicGroupType;
        this.publication.bindingType = _publication.bindingType;
        this.publication.documentType = _publication.documentType;
        this.publication.title = _publication.title;
        this.publication.subtitle = _publication.subtitle;
        this.publication.pages = _publication.pages;
        this.publication.year = _publication.year;
        this.publication.edition = _publication.edition;
        this.publication.languages = _publication.languages;
        _publication.bindingType.id === 3 ? this.publication.link = _publication.link : this.publication.link = '';
        this.publication.printCount = _publication.printCount;
        this.publication.estimatedPrintDeliveryDate = _publication.estimatedPrintDeliveryDate;
    }

    onIsbnAssign($event) {
        this.assignIsbn = $event
    }

    onIsbnChoosen($event) {
        this.choosenIsbnId = $event;
    }

    onCommentChanged($event) {
        this.publication.comment = $event;
    }

    onNormalSaveClick() {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
        });
        this.publicationService.savePublicationWithoutIsbn(new PublicationSaveModel(this.publication),
            Number(this.route.snapshot.paramMap.get('id'))).subscribe(
            () => this.onSavingSuccesfully(), err => {
                console.error(err);
                this._appCommunicationService.loadingOff();
                this.onSavingError();
            });
    }

    onSaveWithOutIsbnClick() {

        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmSaveWithoutIsbn'),
            buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                this.i18nService.getTranslation('Yes') + ']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                this.onNormalSaveClick();
            }
        });

    }

    onSaveWithIsbnClick() {
        const saveModel = new PublicationSaveModel(this.publication);
        if (this.choosenIsbnId !== null && this.choosenIsbnId > 0) {
            saveModel.isbnId = this.choosenIsbnId;
        }
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
        });
        this.publicationService.savePublicationWithIsbn(saveModel,
            Number(this.route.snapshot.paramMap.get('id'))).subscribe(
            (data: any) => {
                this._appCommunicationService.loadingOff()
                if (!data.successful) {
                    this.router.navigate(['/publications']);
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('warning'),
                        color: '#926c38',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('IsbnChangedReportCreated'),
                        timeout: 5000
                    });
                } else {
                    this.onSavingSuccesfully()
                }
            }
            , err => {
                this._appCommunicationService.loadingOff()

                let errorText = null;

                if (err && err.error) {
                    errorText = this.getErrorByCode(err.error);
                }

                console.error(err);
                this.onSavingError(errorText);
            });
    }

    getErrorByCode(error: number): string {
        switch (error) {
            case ErrorCodesEnum.NO_UNUSED_ISBN:
                return getErrorByCode(ErrorCodesEnum.NO_UNUSED_ISBN);
            case ErrorCodesEnum.ISBN_NOT_FOUND:
                return getErrorByCode(ErrorCodesEnum.ISBN_NOT_FOUND);
        }
    }

    onSavingSuccesfully() {
        this._appCommunicationService.loadingOff()
        this.router.navigate(['/publications']);
        this.notificationService.smallBox({
            title: this.i18nService.getTranslation('saved'),
            color: '#659265',
            content: this.i18nService.getTranslation('publicationHasBeenSaved'),
            timeout: 10000
        });

    }

    onSavingError(errorText: string = null) {
        this.notificationService.smallBox({
            title: this.i18nService.getTranslation('error'),
            color: '#923837',
            iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
            content: this.i18nService.getTranslation(errorText ? errorText : 'somethingIsWrongError'),
            timeout: 5000
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/publication-review-view/publication-review-view.component.ts